import React, { useState } from "react";

const Subscribe = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      name: name,
      emailAddress: email,
      isLegacy: true,
    };

    alert("Subscribed successfully!");

    try {
      const response = await fetch(
        "https://ofc-newsletter.onrender.com/api/add/json",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        setName("");
        setEmail("");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="subscribe-form" id="subscribe">
      <form onSubmit={handleSubmit}>
        <h2>I want in!</h2>
        <p>Subscribe to our newsletter!</p>
        <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Join Us!</button>
      </form>
    </div>
  );
};

export default Subscribe;
